import React, { useState } from "react";
import Modal from "react-modal";
import { formatDateTimezon } from "../../common-data/Converts";
import BankDetails from "../BankDetails";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import { getReplace1 } from "../../common-data/Conversions";

const DetailListings = ({ row }) => {
  const iniModvalues = {
    isModOpen: false,
    rowData: "",
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  function closeModal() {
    setModValues(iniModvalues);
  }

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={closeModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "all_documents" ||
            modValues.modName === "bank_statement"
              ? "mod-width-50p"
              : ""
          }`}
        >
          <ModalHeadAndClose
            title={`${
              modValues.rowData?.gym_name
                ? modValues.rowData.gym_name
                : getReplace1(modValues.modName)
            }`}
            onClose={closeModal}
          />

          {modValues.modName === "all_documents" ||
          modValues.modName === "bank_statement" ? (
            <BankDetails
              modName={modValues.modName}
              rowData={modValues.rowData}
            />
          ) : null}
        </div>
      </Modal>

      <div className="user-profile-container staff-onboarding-detail-modal">
        <div className="user-profile-details">
          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">User ID</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.user_id || "-"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Owner</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.name || "NA"}</p>
            </div>
          </div>

          {/* <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">GST Inclusive</p>
          </div>
          <div className="user-details-info">
            <p className="info-name icon">
              {row?.is_gst_inclusive ? (
                 <CheckCircleIcon />
              ) : (
                <CrossCircleIcon />
              )}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">100M Restriction</p>
          </div>
          <div className="user-details-info">
            <p className="info-name icon">
              {row?.is_100 ? (
                <CheckCircleIcon />
              ) : (
               <CrossCircleIcon />
              )}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Rating</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {row?.rating ? (
                fixedTwo(row.rating)
              ) : (
               <CrossCircleIcon />
              )}{" "}
              {row?.rating ? "★" : null}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Google Rating</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {row?.google_rating ? (
                fixedTwo(row.google_rating)
              ) : (
               <CrossCircleIcon />
              )}{" "}
              {row?.google_rating ? "★" : null}
            </p>
          </div>
        </div> */}

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Device ID</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.device_id || "-"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Documents</p>
            </div>
            <div className="user-details-info">
              <p
                className="info-name link"
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "all_documents",
                    rowData: row,
                  }))
                }
              >
                View
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Bank Details</p>
            </div>
            <div className="user-details-info">
              <p
                className="info-name link"
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    modName: "bank_statement",
                    rowData: row,
                  }))
                }
              >
                View
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Date Added</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">description</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.description || "NA"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">latitute</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.lat || "-"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">longitute</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.long || "-"}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailListings;
